import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const AnnouncementBanner = dynamic(() => import('./index'), {
  ssr: false
});

Builder.registerComponent(AnnouncementBanner, {
  name: 'AnnouncementBanner',
  inputs: [
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'label',
      type: 'string'
    },
    {
      name: 'link',
      type: 'string'
    },
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
    },
    {
      name: 'alt',
      type: 'string'
    }
  ]
});
